import { render, staticRenderFns } from "./HistorialReservasFincaComponent.vue?vue&type=template&id=2059e025&"
import script from "./HistorialReservasFincaComponent.vue?vue&type=script&lang=js&"
export * from "./HistorialReservasFincaComponent.vue?vue&type=script&lang=js&"
import style0 from "./HistorialReservasFincaComponent.vue?vue&type=style&index=0&id=2059e025&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports